var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";
var Stream = /** @class */ (function (_super) {
    __extends(Stream, _super);
    function Stream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Stream.prototype.render = function () {
        return (_jsx("div", __assign({ className: "player-wrapper" }, { children: _jsx("div", __assign({ className: "react-player" }, { children: _jsx(ReactPlayer, { url: this.props.src, 
                    //  loop
                    controls: true, playsInline: true, playing: true }) })) })));
    };
    return Stream;
}(React.PureComponent));
Stream.propTypes = {
    src: PropTypes.string.isRequired,
};
export default Stream;



// WEBPACK FOOTER //
// ./src/components/grid/event/Stream.jsx